<style lang="scss" scoped>
.detect-browser-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 120px;
  background: hsla(0, 0%, 0%, 0.8);
  z-index: 99999;
  text-align: center;
  padding: 0 0 10px 0;
}

.detect-browser-banner .text-wrapper {
  display: inline-block;
  vertical-align: top;
  height: 100%;
  width: 290px;
  margin-right: 40px;
}

.detect-browser-banner .text_wrapper__para {
  font-size: 14px;
  color: white;
  margin-top: 20px;
  margin-right: 28px;
  text-align: left;
}

.detect-browser-banner .text-wrapper__dot {
  background: #349ed2;
  display: inline-block;
  border-radius: 2px;
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
  margin-right: 10px;
}

.detect-browser-banner .img-wrapper {
  display: inline-block;
  vertical-align: top;
  background-repeat: no-repeat;
  background-image: url(https://o44j7l4g3.qnssl.com/whitef/detect-browser/google-browser-compressor-1.png);
  background-position: -39px 16px;
  width: 332px;
  height: 100%;
  margin-right: 40px;
}

.detect-browser-banner .download-wrapper {
  display: inline-block;
  vertical-align: top;
  height: 100%;
}

.detect-browser-banner .download-wrapper__logo {
  width: 88px;
  height: 100%;
  margin-right: 20px;
  display: inline-block;
  vertical-align: top;
  background: url(https://o44j7l4g3.qnssl.com/whitef/detect-browser/google-browser-compressor-1.png)
    no-repeat -388px 16px;
}

.detect-browser-banner .download-wrapper__area {
  width: 180px;
  height: 100%;
  vertical-align: top;
  display: inline-block;
  padding-top: 16px;
}

.detect-browser-banner .download-wrapper__download-text {
  color: #34e7f2;
  font-size: 22px;
  margin-bottom: 12px;
}

.detect-browser-banner .download-wrapper__download-btn {
  background-image: linear-gradient(180deg, #f7554d 0%, #ff382e 100%);
  border: 1px solid #e54137;
  border-radius: 6px;
  width: 170px;
  height: 40px;
  color: white;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  display: block;
  text-decoration: none;
}

.detect-browser-banner .download-wrapper__download-btn:visited {
  color: white;
}

.detect-browser-banner .spliter {
  width: 1px;
  height: 80px;
  margin-top: 20px;
  display: inline-block;
  vertical-align: top;
  background-color: hsl(0, 0%, 40%);
  margin-right: 50px;
}
.detect-browser-banner__close-btn {
  background: url(https://o44j7l4g3.qnssl.com/whitef/detect-browser/google-browser-compressor-1.png)
    no-repeat -492px 0;
  width: 34px;
  height: 34px;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
</style>

<template>
  <section class="detect-browser-banner">
    <div class="text-wrapper">
      <div class="detect-browser-banner__close-btn" @click="close"></div>
      <div class="text_wrapper__para">
        <p>
          <span class="text-wrapper__dot"></span>
          未来教室检测到你的浏览器是Interner</p>
        <p>Explorer内核，与编程猫使用的新技术存在</p>
        <p>许多兼容性问题；推荐使用[Google]浏览</p>
        <p>器体验完整功能。</p>
      </div>
    </div>
    <div class="img-wrapper"></div>
    <div class="spliter"></div>
    <div class="download-wrapper">
      <div class="download-wrapper__logo"></div>
      <div class="download-wrapper__area">
        <p class="download-wrapper__download-text">
          Google浏览器
        </p>
        <a class="download-wrapper__download-btn" href="javascript:void(0)" @click="download">立即下载</a>
      </div>
    </div>
  </section>

</template>

<script>
import { detectOS } from '@/utils/utils'
export default {
  props: {
    value: Boolean
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(show) {
        this.$emit('input', show)
      }
    }
  },
  methods: {
    close() {
      this.show = false
    },
    download() {
      const os = detectOS()
      if (/XP/.test(os)) {
        window.open('http://down.codemao.cn/forwin/chrome/chrome-49.exe')
      } else {
        window.open('http://7xns6d.dl1.z0.glb.clouddn.com/chrome/download/googlechrome.exe')
      }
    }
  }

}
</script>
